export default axios => ({
  getFacadeImages: (payload) => axios.get('facade/images', payload),
  getFacadeImage: (facadeImageId) => axios.get(`facade/images/${facadeImageId}`).then(({ data }) => data),
  storeFacadeImages: (payload) => axios.post('facade/images', payload),
  createNormalizedFacadeImage: (facadeImageId, payload) => axios.post(`facade/images/${facadeImageId}/normalize`, payload).then(({ data }) => data),
  storeFacadeImagePoints: (facadeImageId, payload) => axios.post(`facade/images/${facadeImageId}/points`, payload),
  deleteFacadeImage: (facadeImageId) => axios.delete(`facade/images/${facadeImageId}`)
})
